export enum ElementAttributionType {
  PATTERN = 'pattern-attribution',
  PROBLEM = 'problem-attribution',
  PATTERN_DOMAIN = 'pattern-attribution-domain',
  PROBLEM_PATTERN = 'problem-pattern-attribution'
}
